/**
 * isRTLText.ts - Does this text contain right-to-left script?
 *
 * The UI language and the content language are not always the same: an English
 * interface can be showing Arabic questions, and vice versa. Callers decide the
 * direction from both, e.g. `i18n.dir() === 'rtl' || isRTLText(text)`.
 *
 * Covers Hebrew, Arabic, Syriac, Thaana/NKo, Arabic Extended-A and the Arabic
 * presentation forms blocks.
 */

const RTL_CHAR_RE = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

export const isRTLText = (...values: (string | undefined)[]): boolean => {
    for (const v of values) {
        if (v && RTL_CHAR_RE.test(v)) return true;
    }
    return false;
};
